import React from "react";
// import RcTreeSelect, { TreeNode, SHOW_ALL, SHOW_PARENT, SHOW_CHILD } from 'rc-tree-select';
import RcTreeSelect, {
  TreeNode,
  SHOW_ALL,
  SHOW_PARENT,
  SHOW_CHILD
} from "../../_rc-tree-select-1.8.8/src/";
import classNames from "classnames";
export default class TreeSelect extends React.Component {
  static TreeNode = TreeNode;
  static SHOW_ALL = SHOW_ALL;
  static SHOW_PARENT = SHOW_PARENT;
  static SHOW_CHILD = SHOW_CHILD;

  static defaultProps = {
    prefixCls: "ant-select",
    transitionName: "slide-up",
    choiceTransitionName: "zoom",
    showSearch: false,
    dropdownClassName: "ant-select-tree-dropdown"
  };

  static contextTypes = {
    antLocale: React.PropTypes.object
  };

  render() {
    const props = this.props;
    let { size, className, combobox, notFoundContent, prefixCls } = this.props;

    const cls = classNames({
      [`${prefixCls}-lg`]: size === "large",
      [`${prefixCls}-sm`]: size === "small",
      [className]: !!className
    });

    const { antLocale } = this.context;
    if (antLocale && antLocale.Select) {
      notFoundContent = notFoundContent || antLocale.Select.notFoundContent;
    }

    if (combobox) {
      notFoundContent = null;
    }

    let checkable = props.treeCheckable;
    if (checkable) {
      checkable = <span className={`${prefixCls}-tree-checkbox-inner`}></span>;
    }

    return (
      <RcTreeSelect
        {...this.props}
        treeCheckable={checkable}
        className={cls}
        notFoundContent={notFoundContent}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./_antd1.11.2/tree-select/index.jsx